/**
 * @typedef {Object} Peak
 * @property {number} wavenumber
 * @property {number} transmittance
 * @property {number} absorbance
 * @property {number} kind
 * @property {number} assignment
 */

/**
 * Creates annotations for jsgraph that allows to display the result of peak picking
 * @param {array<Peak>} peaks
 * @param {object} [options={}]
 * @param {string} [options.fillColor='green']
 * @param {string} [options.strokeColor='red']
 * @param {function} [options.createFct] (annotation, peak) => {}: callback allowing to add properties
 * @param {string} [options.showAssignment=true] Display the assignment
 * @returns array
 */

export function getAnnotations(peaks, options = {}) {
  const { fillColor = 'green', strokeColor = 'red', creationFct } = options;
  let annotations = peaks.map((peak) => {
    let annotation = {
      line: 1,
      type: 'rect',
      strokeColor: strokeColor,
      strokeWidth: 0,
      fillColor: fillColor,
    };
    if (creationFct) {
      creationFct(annotation, peak);
    }

    enhandeAnnotation(annotation, peak, options);
    return annotation;
  });
  return annotations;
}

function enhandeAnnotation(annotation, peak, options = {}) {
  const { showAssignment = true, assignmentAngle = -45 } = options;
  let labels = [];
  let line = 0;

  if (showAssignment && (peak.element || peak.transition)) {
    labels.push({
      text: `${peak.element || ''} ${peak.transition || ''}`,
      size: '18px',
      angle: assignmentAngle,
      anchor: 'left',
      color: 'darkred',
      position: {
        x: peak.energy,
        y: peak.count,
        dy: `${-15 - line * 14}px`,
      },
    });
    line++;
  }

  annotation.labels = labels;

  annotation.position = [
    {
      x: peak.energy,
      y: peak.count,
      dy: '-10px',
      dx: '-1px',
    },
    {
      x: peak.energy,
      y: peak.count,
      dy: '-5px',
      dx: '1px',
    },
  ];
}
